import React, { useEffect, useState } from 'react';
import { PageLayout } from '@src/common/PageLayout';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { useUser } from '@src/state/user/hooks';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@src/common/Button';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { clearData } from '@src/state/tinRegistrationStatus';
import messages from '@src/common/messages.json';
import { TinRegistrationStatusHeader } from './TinRegistrationStatusHeader';
import { TinStatus } from './TinStatus/TinStatus';
import { FindAnotherTin } from './FindAnotherTin';
import { LearnAbout } from './LearnAbout';

const PageButtons = styled('div', {
  width: 'fitContent',
  marginTop: '3em',
  paddingBottom: '25px',
  fontWeight: 600,
  fontSize: '16px',
  color: '$primary1',
  fontFamily: '$heading',
  display: 'inline-flex',
  marginRight: '15px',
});

const AlertDisplay = styled('div', {
  marginBottom: '2%',
  marginTop: '-16px',
});

export const TinRegistrationStatus = () => {
  const userInfo = useUser.state();
  const router = useRouter();
  const { clearRegistrationData } = clearData();
  const [isTinRegStatusError, setTinRegStatusError] = useState(false);

  const goBack = () => {
    clearRegistrationData();
    router.navigate('/');
  };

  const form = useForm('');
  const searchCriteria = form.getValues('searchCriteria');

  useEffect(() => {
    const pageName = 'epvsecure:tin registration status :results';
    const billingTin =
      searchCriteria && searchCriteria.tin ? searchCriteria.tin : '';
    const requestId =
      searchCriteria && searchCriteria.requestId
        ? searchCriteria.requestId
        : '';
    const trackingNumber =
      searchCriteria && searchCriteria.trackingNumber
        ? searchCriteria.trackingNumber
        : '';
    if (!(billingTin || requestId || trackingNumber)) {
      clearRegistrationData();
      router.navigate('/');
    }
    const siteSectionLevel = {
      siteSectionLevel1: 'tin registration status',
      siteSectionLevel2: 'results',
      siteSectionLevel3: '',
      siteSectionLevel4: '',
      siteSectionLevel5: '',
    };
    adobeTaggingEvent('ON_PAGE_LOAD', {
      userInfo,
      pageName,
      billingTin,
      siteSectionLevel,
    });
  }, []);

  return (
    <PageLayout style={{ height: '100%' }}>
      <TinRegistrationStatusHeader />
      {isTinRegStatusError && (
        <React.Fragment>
          <AlertDisplay>
            <Alert title="We were unable to retrieve your TIN registration">
              {messages.TIN_REGISTRATION_STATUS_FAILED}
            </Alert>
          </AlertDisplay>
        </React.Fragment>
      )}
      <TinStatus />
      <Grid>
        <Grid.Col span={{ sm: '80%', lg: '50%' }}>
          <FindAnotherTin setTinRegStatusError={setTinRegStatusError} />
        </Grid.Col>
        <Grid.Col span={{ sm: '80%', lg: '50%' }}>
          <LearnAbout />
        </Grid.Col>
      </Grid>
      <PageButtons>
        <Button
          type="button"
          id="status-back-button"
          aria-label="click here to go back"
          data-testid="back-button"
          onClick={goBack}
          width="100%"
        >
          Return to Dashboard
        </Button>
      </PageButtons>
    </PageLayout>
  );
};
